import React from 'react'
import { useSelector } from 'react-redux'
import { selectNewsByType } from '../../core/reducers/news'

import News from '../News/News'

function OverviewNews() {
  const newsCointelegraph = useSelector(state => selectNewsByType(state, 'cointelegraph'))
  const newsTheblock = useSelector(state => selectNewsByType(state, 'theblock'))
  const newsDecrypt = useSelector(state => selectNewsByType(state, 'decrypt'))

  if (
    !newsCointelegraph.length &&
    !newsTheblock.length &&
    !newsDecrypt.length
  ) {
    return null
  }

  return (
    <>
      <h3 className="text-oz pb-2 pt-4 my-2 font-normal text-xl">
        Top News
      </h3>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
        <News className="" title="CoinTelegraph" news={newsCointelegraph} />
        <News className="" title="TheBlock" news={newsTheblock} />
        <News className="" title="Decrypt" news={newsDecrypt} />
      </div>
    </>
  )
}

export default OverviewNews
